// Simply Social — official pricing engine
// Prices reflect the current Simply Social price list. Update here when official rates change.

export const SERVICES = [
  {
    key: "social_bar",
    name: "The Social Bar",
    tag: "Sip",
    price: 250,                       // The Social Sip base
    priceLabel: "starts at $250",
    detail: "Mobile bartending · up to 20 guests · 2 hrs · scale up with Pour/Experience/Reserve",
    img: "/media/social-bar.jpg",
  },
  {
    key: "social_set",
    name: "The Social Set",
    tag: "Vibe",
    price: 300,                       // $75/hr × 4-hour minimum
    priceLabel: "starts at $300 (4 hr minimum)",
    detail: "DJ services · $75/hr with 4-hour minimum · weddings by consultation",
    img: "https://customer-assets-gfyr7b9c.emergentagent.net/job_simply-social-events/artifacts/couqhl0g_image000001.webp",
  },
  {
    key: "nightclub",
    name: "The Social Nightclub",
    tag: "Party",
    price: 425,                       // Luxe Lounge (cheaper of the two)
    priceLabel: "starts at $425",
    detail: "Lit Lounge $500 · Luxe Lounge $425 · delivery + setup included",
    img: "https://images.unsplash.com/photo-1598495496118-f8763b94bde5?auto=format&fit=crop&w=1200&q=85",
  },
  {
    key: "supply",
    name: "The Social Supply",
    tag: "Customize",
    price: null,                      // priced by consultation
    priceLabel: "custom quote",
    detail: "Custom cups · Bottle labels · Drink menus · Signature details · priced per project",
    img: "/media/social-supply.jpg",
  },
];

export const ST_LOUIS_TRAVEL_FEE = 75;

// Detect St. Louis service area from a free-text location string.
export function isStLouis(location = "") {
  const s = String(location).toLowerCase();
  return /st\.?\s*louis|saint\s*louis|\bstl\b|missouri|\bmo\b/.test(s);
}

// Quote engine — no invented discounts, no invented multipliers.
// Single service: sum of listed starting prices + St. Louis fee if applicable.
// Multiple services: custom_quote flag → UI shows "Exclusive bundled pricing available. Request a custom quote."
export function bundleQuote({ selectedKeys = [], eventLocation = "" } = {}) {
  const selected = SERVICES.filter(s => selectedKeys.includes(s.key));
  const pricedItems = selected.filter(s => typeof s.price === "number");
  const hasCustomOnly = selected.some(s => s.price === null);
  const stLouis = isStLouis(eventLocation);
  const travelFee = stLouis ? ST_LOUIS_TRAVEL_FEE : 0;

  const subtotal = pricedItems.reduce((sum, s) => sum + s.price, 0);
  const isBundle = selected.length > 1;
  const customQuote = isBundle || hasCustomOnly;

  const total = customQuote ? null : subtotal + travelFee;

  return {
    selected, subtotal,
    isBundle, customQuote,
    stLouis, travelFee,
    total,
  };
}
